import { render, staticRenderFns } from "./ModalRating.vue?vue&type=template&id=26b15b91&scoped=true"
import script from "./ModalRating.vue?vue&type=script&lang=js"
export * from "./ModalRating.vue?vue&type=script&lang=js"
import style0 from "./ModalRating.vue?vue&type=style&index=0&id=26b15b91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b15b91",
  null
  
)

export default component.exports